import { setCookie } from '@src/app/utils/cookieHelpers';
import { parseDomain } from '@src/app/utils/domainHelpers';

export const WebRuntimeCookie = {
    Shell: 'shell',
    Tickets: 'tickets',
    Social: 'social',
    Account: 'account',
} as const;
export type WebRuntimeCookie = typeof WebRuntimeCookie[keyof typeof WebRuntimeCookie];

export const cookieOptions: BranchOption[] = [
    {
        key: WebRuntimeCookie.Shell,
        label: 'Shell branch name',
        cookie: 'shellFeature',
    },
    {
        key: WebRuntimeCookie.Tickets,
        label: 'Tickets branch name',
        cookie: 'ticketsFeature',
    },
    {
        key: WebRuntimeCookie.Social,
        label: 'Social branch name',
        cookie: 'socialFeature',
    },
    {
        key: WebRuntimeCookie.Account,
        label: 'Account branch name',
        cookie: 'accountFeature',
    },
];

export function setCookies(cookies: Partial<Record<WebRuntimeCookie, string>>): void {
    if (!cookies || Object.keys(cookies).length === 0) {
        return;
    }

    const origin = parseDomain(window.location.hostname).origin;
    let hasSetCookie = false;

    for (const key in cookies) {
        if (cookies[key as WebRuntimeCookie]) {
            const cookie = cookieOptions.find((option) => option.key === key);
            if (!cookie) {
                continue;
            }

            setCookie(cookie.cookie, cookies[key as WebRuntimeCookie]!, 365, false, `.${origin}`);
            hasSetCookie = true;
        }
    }

    if (hasSetCookie) {
        if (isOnSetFeaturePath()) {
            window.location.replace('/'); // Redirect to the main page after setting cookies and clear the params
        } else {
            window.location.reload(); // Reload the page so that the lambda resolves the correct logic
        }
    }
}

export function resetCookies(): void {
    cookieOptions.forEach((option) => {
        const origin = parseDomain(window.location.hostname).origin;
        setCookie(option.cookie, '', -1, false, `.${origin}`); // Set the cookie to expire immediately
    });

    window.location.reload(); // Reload the page so that the lambda resolves the correct logic
}

export function isOnSetFeaturePath() {
    return window.location.pathname === '/set-feature';
}

type BranchOption = {
    key: WebRuntimeCookie;
    label: string;
    cookie: string;
};
